import { Flex } from 'antd'
import { GetOrCreateViewsMutation } from 'types/graphql'

import TableViewHeader from 'src/components/TableViews/TableViewHeader'
import TableViewTabs from 'src/components/TableViews/TableViewTabs'
import { TableViewMode } from 'src/fetch/views/views'
import { TableView } from 'src/models/TableViews/TableView'
import { TableViewManager } from 'src/models/TableViews/TableViewManager'
import { RefetchFnType } from 'src/types'

type Props = {
  generateDefaultViews: () => Promise<GetOrCreateViewsMutation>
  isLoadingViewData: boolean
  isLoadingViews: boolean
  mode: TableViewMode
  onSaveViewChanges: () => Promise<unknown>
  onSelectedViewChange: (view: TableView) => Promise<unknown>
  searchInputRef?: React.RefObject<HTMLInputElement>
  searchQuery: string
  setSearchQuery: (value: string) => void
  refetchViewData: RefetchFnType
  tableViewManager: TableViewManager
  isCsvEnabled: boolean
}
const TableViewControls = ({
  generateDefaultViews,
  isLoadingViewData,
  isLoadingViews,
  mode,
  onSaveViewChanges,
  onSelectedViewChange,
  searchInputRef,
  searchQuery,
  setSearchQuery,
  refetchViewData,
  tableViewManager,
  isCsvEnabled,
}: Props) => {
  return (
    <Flex vertical gap="16px" className="govwell-table-view-editor">
      <TableViewTabs
        generateDefaultViews={generateDefaultViews}
        isLoading={isLoadingViews}
        mode={mode}
        onSelectedViewChange={onSelectedViewChange}
        tableViewManager={tableViewManager}
      />
      <TableViewHeader
        isLoadingViews={isLoadingViews}
        isLoadingViewData={isLoadingViewData}
        mode={mode}
        onSaveChanges={onSaveViewChanges}
        onSearchQueryChange={setSearchQuery}
        refetch={refetchViewData}
        searchInputRef={searchInputRef}
        searchQuery={searchQuery}
        tableViewManager={tableViewManager}
        isCsvEnabled={isCsvEnabled}
      />
    </Flex>
  )
}

export default React.memo(TableViewControls)
